/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Typography } from "@mui/material";

const DeleteDialogPanel = (props) => {
    const deleteType = props.deleteType;

    return (
        <Fragment>
            <div
                style={{
                    width: "70%",
                    maxWidth: "760px",
                    padding: "24px",
                    // padding: '24px',
                    // border: '1px solid red'
                }}
            >
                {deleteType === "REMOVE" && (
                    <>
                        <Typography variant='h2'>Remove model.</Typography>
                        <Typography variant='subtitle1' mt={3}>
                            Please confirm you want to remove this webpage from where it was set.
                        </Typography>
                        <Typography variant='subtitle1' mt={3}>
                            The webpage will not be deleted, just removed, here where it was used.
                        </Typography>
                    </>
                )}

                {/*{deleteType === 'DELETE' && (*/}
                {/*    <>*/}
                {/*        <Typography variant='h2'>Delete image from Library.</Typography>*/}
                {/*        <Typography variant='subtitle1' mt={3}>*/}
                {/*            Please confirm you want to remove this image from where it was set.*/}
                {/*        </Typography>*/}
                {/*        <Typography variant='subtitle1' mt={3}>*/}
                {/*            The image will still be available in the Image Library.*/}
                {/*        </Typography>*/}
                {/*    </>*/}
                {/*)}*/}
            </div>
        </Fragment>
    );
};

export default DeleteDialogPanel;
